<div class="categories-field">
  <tui-textarea
    class="field_height_min"
    [tuiSkeleton]="loading"
    [ngModel]="selectedCategoriesStringify"
    [expandable]="true"
    [tuiTextfieldAppearance]="mode === 'view' ? 'textfield' : 'textfield-edit'"
    [readOnly]="true"
    [tuiTextfieldSize]="textfieldSize"
  >
    <ng-content></ng-content>
  </tui-textarea>

  <button
    *ngIf="mode === 'edit'"
    tuiButton
    class="button"
    size="m"
    appearance="outline-grayscale"
    tuiAppearanceMode="checked"
    [tuiSkeleton]="loading"
    (click)="selectCategories()"
  >
    {{ 'components.lpCategoriesField.buttons.selectCategories' | translate }}
  </button>
</div>
